module.exports = {
    uuid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

        for (var i = 0; i < 10; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    },
    hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    },
    fileIconColor(extension) {
        switch (extension.toLowerCase()) {
            case 'zip':
            case 'rar':
                return '#ACACAC';
            case 'rtf':
            case 'doc':
            case 'docx':
                return '#307CF1';
            case 'xls':
            case 'xlsx':
                return '#0F9D58';
            case 'stl':
                return '#D24726';
            case 'pdf':
                return '#E13D34';
            case 'txt':
                return '#5EB533';
            case 'mp3':
            case 'wma':
            case 'm4a':
            case 'flac':
                return '#8E44AD';
            case 'mp4':
            case 'wmv':
            case 'mov':
            case 'avi':
            case 'mkv':
                return '#7A3CE7';
            case 'bmp':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'png':
                return '#F4B400';
            default:
                var hash = 0,
                    str = extension;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return '#' + hash;
        }
    }
};
